module.exports = __webpack_public_path__ + "img/micromall_backstage4.f7a4e926.png";